<template>
    <div class="modal-card" style="overflow: visible;">
        <header class="modal-card-head">
            <p class="modal-card-title">Créer un événement</p>
        </header>
        <section class="modal-card-body">
            <form method="POST">
                <input type="hidden" name="timeline" v-model="form.timeline">

                <!-- Event date field -->
                <div class="columns" style="margin-bottom: 0;">
                    <div class="column is-half">
                        <b-field label="Date de début" :type="form.errors.has('started') ? 'is-danger' : ''" :message="form.errors.first('started')">
                            <b-input type="text" v-model="form.started" autofocus></b-input>
                        </b-field>
                    </div>
                    <div class="column is-half">
                        <b-field label="Date de fin" :type="form.errors.has('ended') ? 'is-danger' : ''" :message="form.errors.first('ended')">
                            <b-input type="text" v-model="form.ended"></b-input>
                        </b-field>
                    </div>
                </div>

                <!-- Title field -->
                <b-field label="Titre de l'événement" :type="form.errors.has('title') ? 'is-danger' : ''" :message="form.errors.first('title')">
                    <b-input type="text" v-model="form.title" maxlength="100" has-counter></b-input>
                </b-field>

                <!-- Description field -->
                <b-field label="Description de l'événement" :type="form.errors.has('description') ? 'is-danger' : ''" :message="form.errors.first('description')">
                    <b-input type="textarea" v-model="form.description" @keydown.enter.native.prevent maxlength="1000" has-counter> </b-input>
                </b-field>

                <!-- Draft field -->
                <b-field>
                    <b-switch v-model="draft" type="is-success">
                        Brouillon
                    </b-switch>
                </b-field>
            </form>
        </section>
        <footer class="modal-card-foot" style="overflow: visible;">
            <div class="field is-grouped">
                <div class="control">
                    <div class="field has-addons">
                        <div class="control">
                            <a class="button is-primary" @click="submit(action)">Enregistrer</a>
                        </div>
                        <div class="control">
                            <b-dropdown>
                                <a class="button is-primary" slot="trigger">
                                    <i class="fa fa-angle-down"></i>
                                </a>

                                <b-dropdown-item has-link>
                                    <a @click="submit('show')" :class="action === 'show' ? 'is-selected' : ''">Enregistrer et accéder à l'événement créé</a>
                                </b-dropdown-item>
                                <b-dropdown-item has-link>
                                    <a @click="submit('new')" :class="action === 'new' ? 'is-selected' : ''">Enregistrer et créer un nouvel événement</a>
                                </b-dropdown-item>
                                <b-dropdown-item has-link>
                                    <a @click="submit('back')" :class="action === 'back' ? 'is-selected' : ''">Enregistrer et retourner à la ligne du temps</a>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
                <div class="control">
                    <button class="button" type="button" @click="$parent.close()">Annuler</button>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import Form from 'form-backend-validation';

export default {
    props: ['timeline'],

    data() {
        return {
            draft: false,
            form: new Form({
                timeline: 0,
                started: '',
                ended: '',
                title: '',
                description: '',
                status: 'published'
            }),
            action: 'show'
        }
    },

    watch: {
        draft: function (val) {
            this.form.status = (val == true) ? 'draft' : 'published';
        }
    },
    
    methods: {

        submit(action) {

            if (action) {
                this.action = action;
            }

            this.form.post('/api/v1/events').then( response => {

                this.$buefy.toast.open({
                    message: 'Votre événement a été enregistré',
                    type: 'is-success'
                });

                switch(this.action) {
                    case 'show':
                        this.$parent.close();
                        this.$router.push({ name: 'events.show', params: { id: response.id }});
                        break;
                    case 'new':
                        Bus.$emit('timeline.fetch');
                        this.form.reset();
                        break;
                    case 'back':
                        Bus.$emit('timeline.fetch');
                        this.$parent.close();
                        break;
                    default:
                        this.$parent.close();
                        this.$router.push({ name: 'events.show', params: { id: response.id }});
                }

            }).catch(response => {
                this.$buefy.toast.open({
                    message: 'Une erreur s\'est produite',
                    type: 'is-danger'
                });
            });
        },
    },

    created() {
        this.form.setInitialValues({
            timeline: this.timeline.id,
            started: '',
            ended: '',
            title: '',
            description: '',
            status: 'published'
        });

        this.form.populate({
            timeline: this.timeline.id
        });
    }
}
</script>

<style>
    a.is-selected {
        font-weight: bolder;
    }
</style>